import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import TextField from 'material-ui/TextField'
import Snackbar from 'material-ui/Snackbar'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import Button from './Button'
import { Grid } from 'react-flexbox-grid'

const materialUiTheme = {
  fontFamily: 'Quicksand, sans-serif',
  borderRadius: '2px',
  palette: {
    primary1Color: '#C8EF62',
    textColor: '#334664',
    borderColor: '#d8d8d8',
  },
  snackbar: {
    backgroundColor: '#C8EF62',
  },
  raisedButton: {
    color: '#C8EF62',
    textColor: '#F4F2F1',
    letterSpacing: '2px',
  },
}

class Formular extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      email: '',
      message: '',
      showNotification: false,
      showErrorNotification: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.hideNotification = this.hideNotification.bind(this)
    this.hideErrorNotification = this.hideErrorNotification.bind(this)
  }

  hideNotification() {
    this.setState({ showNotification: false })
  }

  hideErrorNotification() {
    this.setState({ showErrorNotification: false })
  }

  handleSubmit(event) {
    event.preventDefault()
    console.log(this.state)

    if (
      this.state.email === '' ||
      this.state.name == '' ||
      this.state.email == ''
    ) {
      this.setState({ showErrorNotification: true })
      return
    }
    this.sendFormData(this.state.email, this.state.name, this.state.message)
  }

  sendFormData(email, name, message) {
    let data = {
      email: email,
      name: `${name}`,
      text: message,
    }

    let request = new XMLHttpRequest()
    request.open('POST', 'https://mtoi.api.holzmayer.me/form.php', true)
    request.onreadystatechange = oEvent => {
      if (request.readyState === 4) {
        if (request.status === 200) {
          this.setState({
            showNotification: true,
            name: '',
            email: '',
            name: '',
            message: '',
          })
        } else {
          console.log('Error', request.statusText)
          this.setState({ showErrorNotification: true })
        }
      }
    }

    request.setRequestHeader(
      'Content-type',
      'application/x-www-form-urlencoded'
    )
    request.send(this.serialize(data))
  }

  serialize(obj) {
    var str = []
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
      }
    return str.join('&')
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} autoComplete="new-password">
        <MuiThemeProvider muiTheme={getMuiTheme(materialUiTheme)}>
          <Grid>
            <TextField style={{ visibility: 'hidden', position: 'absolute' }} />
            <TextField
              id={'name'}
              value={this.state.name}
              onChange={event => this.setState({ name: event.target.value })}
              floatingLabelText="Name"
              autoComplete="new-password"
              style={{ width: '100%' }}
            />
            <br />
            <TextField
              id={'email'}
              value={this.state.email}
              onChange={event => this.setState({ email: event.target.value })}
              floatingLabelText="E-Mail"
              autoComplete="new-password"
              style={{ width: '100%' }}
            />
            <br />
            <TextField
              id={'message'}
              value={this.state.message}
              onChange={event => this.setState({ message: event.target.value })}
              floatingLabelText="Nachricht"
              autoComplete="new-password"
              multiLine={true}
              rows={3}
              style={{ width: '100%' }}
            />
            <br />
            <Button type="submit" onClick={this.handleSubmit}>
              Absenden
            </Button>
            <Snackbar
              open={this.state.showNotification}
              onRequestClose={this.hideNotification}
              autoHideDuration={4000}
              message={
                <div className="snackbar-message">Kontaktanfrage gesendet.</div>
              }
            />
            <Snackbar
              bodyStyle={{ backgroundColor: '#d44242', color: '#fafafa' }}
              open={this.state.showErrorNotification}
              onRequestClose={this.hideErrorNotification}
              autoHideDuration={4000}
              message={
                <div className="snackbar-message">
                  Die Nachricht konnte <b>nicht</b> gesendet werden.
                </div>
              }
            />
          </Grid>
        </MuiThemeProvider>
      </form>
    )
  }
}

export default Formular



// WEBPACK FOOTER //
// ./src/components/contact/Formular/index.js